import React from "react";

export function TextAlpha(props) {

    return (
            <span className={props.className} onClick={props.onClick}>{props.text}</span>
    )
}
